import React from 'react';
import Type from 'prop-types';
import { ListItem, ListItemText, ListItemSecondaryAction, Typography } from "@mui/material";
import { FormattedNumber } from 'components';
import { useTranslation } from 'hooks';
import styles from './InvoiceItem.module.css';

const InvoiceItem = (props) => {
  const { t } = useTranslation();
  const {
    invoice: { documentNumber, balanceDue, total },
  } = props;

  const renderInvoiceTotal = () => {
    if (!total) {
      return null;
    }

    return (
      <>
        {`${t('amount')}: `}
        <FormattedNumber
          classes={{ root: styles.amount }}
          value={total}
          options={{
            currency: 'RUB',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }}
          color="textPrimary"
          variant="body1"
          component="span"
        />
      </>
    );
  };

  const renderBalanceDue = () => {
    if (!balanceDue) {
      return null;
    }

    return (
      <>
        {`${t('invoiceBalanceDue')}: `}
        <FormattedNumber
          value={balanceDue}
          options={{
            currency: 'RUB',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }}
          color="textSecondary"
          variant="body1"
          component="span"
        />
      </>
    );
  };

  return (
    <ListItem button>
      <ListItemText
        primary={renderInvoiceTotal()}
        secondary={renderBalanceDue()}
        secondaryTypographyProps={{ variant: 'body1' }}
      />

      {documentNumber && (
        <ListItemSecondaryAction>
          <Typography color="textSecondary">{`№ ${documentNumber}`}</Typography>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};

InvoiceItem.propTypes = {
  invoice: Type.shape({
    documentNumber: Type.string,
    balanceDue: Type.number.isRequired,
    total: Type.number.isRequired,
    overdueDays: Type.number.isRequired,
  }).isRequired,
};

export default InvoiceItem;
